import { Building } from '@dreryk/address-common-api';

import { BindingCreator } from '@dreryk/react-common';
import { BuildingInput } from '@dreryk/react-components';

const BUILDING_FIELD_NAME = 'building';
const BUILDING_FIELD_MAX_LENGTH = 20;

export type BuildingFormBeanPart = {
   [BUILDING_FIELD_NAME]: Building | null;
};

type BuildingFieldProps = {
   readonly register: BindingCreator<BuildingFormBeanPart, typeof BUILDING_FIELD_NAME>;
};

// TODO: DREGAB-19455 - rozszerzenie i dodanie Grid z react-components zamiast GridElement + pozostałe z tego folderu
export const BuildingField = (props: BuildingFieldProps): JSX.Element => {
   return (
      <BuildingInput
         controller={props.register(BUILDING_FIELD_NAME, {
            required: true,
            /*
             * TODO: DREGAB-19275 - Poprawa walidacji tak by populowała walidacje z wnętrza komponentu react-components
             * i nie trzeba było ich powtarzać ponownie podczas rejestracji pola
             */
            maxLength: BUILDING_FIELD_MAX_LENGTH,
         })}
         testId={BUILDING_FIELD_NAME}
      />
   );
};
